exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#change-password--form input,#change-password--form label{font-size:12px}.disabled{background-color:#d3d3d3!important;cursor:not-allowed!important;pointer-events:none!important}#result-text{text-align:center;color:#2a579a}#result-text--card{width:520px!important;height:40px!important;line-height:10px}.errorColor{color:red!important}.noDisplay{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0896a735","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/login/ResetPassword.vue
// module id = 2242
// module chunks = 0